import {
  ROLE_PROOF_READER,
  ROLE_SYSTEM_ADMIN,
  ROLE_PROJECT_MNG,
  ROLE_QA_EXPERT,
  ROLE_LSP,
} from '@/utils/const.js';

export default [
  {
    path: '/reports/:view?/filters/reports/',
    name: 'reports',
    component: () => import('@/views/reports/index.vue'),
    meta: {
      title: 'Reports list',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
  {
    path: '/reports/detail/:id',
    name: 'reports.detail',
    component: () => import('@/views/reports/report_detail/index.vue'),
    meta: {
      title: 'Report detail',
      middleware: {
        access: 'auth',
        rules: [
          ROLE_PROOF_READER,
          ROLE_SYSTEM_ADMIN,
          ROLE_PROJECT_MNG,
          ROLE_QA_EXPERT,
          ROLE_LSP,
        ],
      },
    },
  },
];
